import * as React from 'react';
import PropTypes from 'prop-types';

const SvgActionsCancelCircleHighlightedLarge = React.forwardRef(
  ({ color, size, title, titleId, ...props }, ref) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 48 48"
      ref={ref}
      fill={color}
      width={size}
      height={size}
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <path
        fillRule="evenodd"
        d="M24 5c10.477 0 19 8.523 19 19s-8.523 19-19 19S5 34.477 5 24 13.523 5 24 5zm0 18.293l-8.132-8.132a.5.5 0 00-.707.707L23.293 24l-8.132 8.132a.5.5 0 00.707.707L24 24.707l8.132 8.132a.5.5 0 00.707-.707L24.707 24l8.132-8.132a.5.5 0 00-.707-.707L24 23.293z"
      />
    </svg>
  )
);
SvgActionsCancelCircleHighlightedLarge.defaultProps = {
  color: 'currentColor',
  size: 48,
  title: undefined,
  titleId: undefined
};
SvgActionsCancelCircleHighlightedLarge.propTypes = {
  color: PropTypes.string,
  size: PropTypes.number,
  title: PropTypes.string,
  titleId: PropTypes.string
};
export default SvgActionsCancelCircleHighlightedLarge;
